<div mat-dialog-title>
  <h1 class="titulo-simpli">¡{{title}}!</h1>
  <small class="subtitulo-simpli">{{subtitle}}</small>
</div>

<div mat-dialog-content>

  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top" style="text-align: center;">

      <small class="textoCajaGrande" style="font-size: 17px;">
        <span class="material-icons animated bounceIn iconstyle" [ngStyle]="{'color':this.coloricon}">
          {{icon}}
        </span>
        <br>
          <span class="animate__animated animate__fadeIn" style="font-weight: 600;color: #4d4d4d;font-size: 1.1em;">{{mensajeprincipal}}</span><br><br>


          <div style="font-weight:400; width: 500px;text-align: justify;margin: 0 auto;">{{mensajenegrita}}</div>

          <div style="text-align: center;margin-top: 40px;margin-bottom: 20px;">    
            <button  mat-flat-button class="primary-button" type="button" (click)="contactar_cx()">Contactar con Asistencia al Cliente</button>
          </div>

        </small>

      </div>

    </div>

  </div>

  <div mat-dialog-actions>
    <button  mat-flat-button class="secondary-button" type="button" (click)="close_dialog()">Cerrar</button>
  </div>